<template>
  <v2-row noSpace>
    <v2-col col12 noSpaceX noSpace>
      <v2-select
        :placeholder="$t('quickLaunch.placeholders.selectContact')"
        :label="$t('quickLaunch.labels.contact')"
        v-model="contact"
        name="contact"
        optionLabel="last_name"
        :options="options"
        :searchable="true"
        :internalSearch="true"
        :customLabel="setCustomLabel"
        @change="loadProjectContact"
      ></v2-select>
      <div class="flex">
        <div>{{ $t("quickLaunch.labels.uploadImage") }}</div>
        <v2-switch small :value="addImage" @input="toggleAddImage" name="addImage"></v2-switch>
        <div class="flex items-center" @click="replaceImage()" v-if="addImage && image">
          <v2-icon
            class="ml-4 cursor-pointer"
            :data="require('@icon/Icon=trash.svg')"
            width="20px"
            height="20px"
            color="red"
          ></v2-icon>
        </div>
        <div
          class="flex items-center"
          @click="cancelReplaceImage()"
          v-if="addImage && !image && componentContact && componentContact.image_override"
        >
          <v2-icon
            class="ml-4 cursor-pointer"
            :data="require('@icon/Icon=x.svg')"
            width="20px"
            height="20px"
            color="red"
          ></v2-icon>
        </div>
      </div>
      <v2-row v-if="addImage" class="mt-4">
        <v2-col class="w-full relative" style="min-height: 300px" v-if="image">
          <v-spinner :bgColor="'transparent'" :loading="!imageIsReady" size="10"></v-spinner>
          <v2-lazy-load
            v-if="imageIsReady"
            :image="imageUrl"
            bgColor="rgba(241, 242, 246, 1)"
            class="flex justify-center h-full"
          ></v2-lazy-load>
        </v2-col>
        <v2-col col12 style="height: 400px" class="relative" v-if="!image">
          <div :class="['mt-0 h-full v2-backoffice-uppy']" id="trigger-envivo-upload-box-contact-image"></div>
          <v2-uppy-upload
            :withMediaLibraryButton="true"
            id="contact-image"
            :locale="teams[$route.params.team].account.locale"
            target="#trigger-envivo-upload-box-contact-image"
            componentTagname="tb-image"
            :inline="true"
            :hideUploadButton="true"
            :create-file="createNewFile"
            :uploadConfig="uploadConfig"
            @completed="completeFileHandler"
            @openMediaLibrary="openMediaLibrary('image')"
          ></v2-uppy-upload>
        </v2-col>
      </v2-row>
      <div class="flex mt-8">
        <div>{{ $t("quickLaunch.labels.uploadVideo") }}</div>
        <v2-switch small :value="addVideo" @input="toggleAddVideo" name="addVideo"></v2-switch>
        <div class="flex items-center" @click="replaceVideo()" v-if="addVideo && video">
          <v2-icon
            class="ml-4 cursor-pointer"
            :data="require('@icon/Icon=trash.svg')"
            width="20px"
            height="20px"
            color="red"
          ></v2-icon>
        </div>
        <div
          class="flex items-center"
          @click="cancelReplaceVideo()"
          v-if="addVideo && !video && componentContact && componentContact.video_override"
        >
          <v2-icon
            class="ml-4 cursor-pointer"
            :data="require('@icon/Icon=x.svg')"
            width="20px"
            height="20px"
            color="red"
          ></v2-icon>
        </div>
      </div>
      <v2-row v-if="addVideo">
        <v2-col class="w-full items-center relative" v-if="video">
          <v-spinner :loading="!videoIsReady" :bgColor="'transparent'" size="10"></v-spinner>
          <div ref="videoContainer" style="height: 300px; width: 100%" :style="'max-width:' + videoMaxWidth + 'px'">
            <video-player
              v-if="videoIsReady && videoOptionsSet"
              class="video-player-box"
              :class="{ 'video-loaded': videoIsLoaded }"
              ref="videoPlayer"
              :options="playerOptions"
              :playsinline="true"
              @ready="onLoad"
            >
            </video-player>
          </div>
        </v2-col>
        <v2-col col12>
          <div class="flex justify-end w-full">
            <a @click="cancelReplaceVideo()" v-if="!video && componentContact && componentContact.video_override">{{
              $t("actions.cancel")
            }}</a>
          </div>
        </v2-col>
        <v2-col col12 style="height: 400px" class="relative" v-if="!video">
          <div :class="['mt-0 h-full v2-backoffice-uppy']" id="trigger-envivo-upload-box-contact-video"></div>
          <v2-uppy-upload
            :withMediaLibraryButton="true"
            id="contact-video"
            :locale="teams[$route.params.team].account.locale"
            target="#trigger-envivo-upload-box-contact-video"
            componentTagname="tb-video"
            :inline="true"
            :hideUploadButton="true"
            :create-file="createNewFile"
            :uploadConfig="uploadConfig"
            @completed="completeFileHandler"
            @openMediaLibrary="openMediaLibrary('video')"
          ></v2-uppy-upload>
        </v2-col>
      </v2-row>
    </v2-col>
    <v2-col col12 class="items-end" noSpaceX noSpace>
      <v2-button outline primary @click.native="saveComponent(false)">{{ $t("quickLaunch.actions.save") }}</v2-button>
    </v2-col>
  </v2-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";

export default {
  name: "QuickLaunchContact",
  components: {
    videoPlayer,
  },
  props: {
    options: Array,
    component: Object,
  },
  data() {
    return {
      componentContact: null,
      contact: {},
      video: null,
      image: null,
      addVideo: false,
      addImage: false,
      uploadConfig: {},
      videoUrl: "",
      imageUrl: "",
      imageAmountTry: 10,
      imageTimeWaitStart: 3000,
      imageTimer: null,
      videoAmountTry: 10,
      videoTimeWaitStart: 3000,
      videoTimer: null,
      playerOptions: {},
      videoIsLoaded: false,
      videoOptionsSet: false,
      containerHeight: 0,
      windowSize: "lg",
      imageMaxWidth: 0,
      videoMaxWidth: 0,
      contactHasChanged: false,
      imageHasChanged: false,
      videoHasChanged: false,
      selectedFileFolder: null,
      hasChanged: false,
    };
  },
  created() {
    if (this.component.relations.length > 0) {
      this.componentContact = this.component.relations[0];
      this.image = this.componentContact.image_override;
      this.video = this.componentContact.video_override;
    }
    if (this.image) {
      this.addImage = true;
      this.untilReadyImage();
    }
    if (this.video) {
      this.addVideo = true;
      this.untilReadyVideo();
    }
    this.preselectContact();
    this.setPlayerOptions();
    this.adjustAfterResize();
    window.addEventListener("resize", this.adjustAfterResize);
    this.$eventbus.$on("closeMediaLibrary", this.handleMediaLibrarySelector);
    this.$eventbus.$on("saveComponents", () => {
      this.saveComponent(true);
    });
  },
  mounted() {
    this.adjustAfterResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.adjustAfterResize);
    this.$eventbus.$off("closeMediaLibrary", this.handleMediaLibrarySelector);
  },
  methods: {
    ...mapActions([
      "createComponentRelation",
      "createProjectFiles",
      "updateContactComponent",
      "getProjectFile",
      "getProjectFileImagePreview",
      "getProjectFilePreview",
      "deleteContactOverride",
      "getLibraryFile",
      "getLibraryFilePreview",
      "getLibraryImagePreview",
      "getTemplateFilePreview",
      "getProjectContact",
    ]),
    preselectContact() {
      if (this.componentContact) {
        this.options.find((obj) => {
          if (this.componentContact.uid === obj.uid) {
            this.contact = obj;
          }
        });
      }
    },
    setCustomLabel(client) {
      const name = this.$h.formatName(client);
      return `${name}`;
    },
    toggleAddVideo() {
      this.setChangedComp();
      this.addVideo = !this.addVideo;
    },
    toggleAddImage() {
      this.setChangedComp();
      this.addImage = !this.addImage;
    },
    replaceImage() {
      this.image = null;
    },
    cancelReplaceImage() {
      this.image = this.componentContact.image_override;
    },
    replaceVideo() {
      this.video = null;
    },
    cancelReplaceVideo() {
      this.video = this.componentContact.video_override;
    },
    setPlayerOptions() {
      if (this.video) {
        this.playerOptions = {
          fill: true,
          aspectRatio: this.video.ratio === 0.75 ? "4:3" : "16:9",
          autoplay: false,
          fluid: true,
          preload: "none",
          language: "de",
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [
            {
              type: this.video.mime_type,
            },
          ],
        };
      }
    },
    onLoad() {
      this.videoIsLoaded = true;
    },
    handleMediaLibrarySelector(data) {
      this.selectedFileFolder = data.selectedObjects[0].folder.uid;
      const d = {
        uid: data.selectedObjects[0].uid,
        type: "library",
        folder: this.selectedFileFolder,
      };
      if (data.selectedObjects[0].display_type === "image") {
        this.image = d;
        this.untilReadyImage();
        this.imageHasChanged = true;
      } else if (data.selectedObjects[0].display_type === "video") {
        this.video = d;
        this.untilReadyVideo();
        this.videoHasChanged = true;
      }
    },
    setChangedComp() {
      this.hasChanged = true;
      this.$eventbus.$emit("setUnsavedComponents", this.component.uid);
    },
    saveComponent(isEvent = false) {
      if (this.hasChanged) {
        const vm = this;
        let data = {};
        if (this.contactHasChanged) {
          const data = {
            customLoading: true,
            params: {
              project: vm.currentProject.uid,
              component: vm.component.uid,
            },
            data: {
              uid: this.contact.uid,
              type: "contact",
            },
          };
          vm.createComponentRelation(data);
        }
        const p1 = new Promise((resolve, reject) => {
          if (vm.componentContact.image_override && !this.addImage) {
            data = {
              project: vm.currentProject.uid,
              contact: vm.contact.uid,
              override: vm.componentContact.image_override.override_uid,
            };
            vm.deleteContactOverride(data)
              .then(() => {
                vm.componentContact.image_override = null;
                vm.image = null;
                resolve();
              })
              .catch((err) => {
                reject(err);
              });
          } else if (this.image && this.imageHasChanged) {
            let fileType = "project";
            if (this.image.type === "template" || this.image.file_type === "templatefile") {
              fileType = "template";
            } else if (this.image.type === "library" || this.image.file_type === "libraryfile") {
              fileType = "library";
            }
            data = {
              customLoading: true,
              params: {
                project: vm.currentProject.uid,
                contact: vm.contact.uid,
              },
              data: {
                file_uid: this.image.uid,
                file_type: fileType,
                type: "image",
              },
            };
            vm.updateContactComponent(data)
              .then(() => {
                this.contactHasChanged = true;
                this.imageHasChanged = true;
                resolve();
              })
              .catch((err) => {
                reject(err);
              });
          } else {
            resolve();
          }
        });
        const p2 = new Promise((resolve, reject) => {
          if (vm.componentContact.video_override && !this.addVideo) {
            data = {
              project: vm.currentProject.uid,
              contact: vm.contact.uid,
              override: vm.componentContact.video_override.override_uid,
            };
            vm.deleteContactOverride(data)
              .then(() => {
                vm.componentContact.video_override = null;
                vm.video = null;
                resolve();
              })
              .catch((err) => {
                reject(err);
              });
          } else if (this.video && this.videoHasChanged) {
            let fileType = "project";
            if (this.video.type === "template" || this.video.file_type === "templatefile") {
              fileType = "template";
            } else if (this.video.type === "library" || this.video.file_type === "libraryfile") {
              fileType = "library";
            }
            data = {
              customLoading: true,
              params: {
                project: vm.currentProject.uid,
                contact: vm.contact.uid,
              },
              data: {
                file_uid: this.video.uid,
                file_type: fileType,
                type: "video",
              },
            };
            vm.updateContactComponent(data)
              .then(() => {
                vm.contactHasChanged = true;
                vm.videoHasChanged = true;
                resolve();
              })
              .catch((err) => {
                reject(err);
              });
          } else {
            resolve();
          }
        });
        Promise.all([p1, p2])
          .then(() => {
            vm.$eventbus.$emit("componentSavedSuccess", this.component.uid, isEvent);
            vm.hasChanged = false;
            if (!isEvent) {
              vm.$snotify.success(vm.$t("quickLaunch.toasts.saveComponent.success"), vm.$t("toasts.success"), {
                icon: vm.$successIcon,
              });
            }
          })
          .catch((err) => {
            console.log("ERR", err);
            vm.$eventbus.$emit("componentSavedError", this.component.uid);
            if (!isEvent) {
              vm.$snotify.error(vm.$t("quickLaunch.toasts.saveComponent.error"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
            }
          });
      }
    },
    createNewFile(data) {
      return new Promise((resolve, reject) => {
        var vm = this;
        data.params.project = this.currentProject.uid;
        data.customLoading = true;
        vm.createProjectFiles(data)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            vm.$snotify.error(vm.$t("quickLaunch.toasts.uploadFile.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
            reject(err);
          });
      });
    },
    completeFileHandler(data) {
      this.setChangedComp();
      if (data.display_type === "image") {
        this.image = data;
        this.untilReadyImage();
        this.imageHasChanged = true;
      } else if (data.display_type === "video") {
        this.video = data;
        this.untilReadyVideo();
        this.videoHasChanged = true;
      }
    },
    openMediaLibrary(type) {
      const data = {
        whitelist: type === "image" ? ["image"] : ["video"],
        autoClose: true,
      };
      this.$eventbus.$emit("openMediaLibrary", data);
    },
    getImagePreview() {
      this.imageUrl = "";
      const data = {
        team: this.$route.params.team,
        project: this.currentProject.uid,
        template: this.currentProject.template.uid,
        file: this.image.uid,
        customLoading: true,
        folder: this.selectedFileFolder || this.image.folder,
        params: {
          width: Math.round(290 / this.image.ratio),
          height: "290",
        },
      };
      if (this.image) {
        if (this.image.type === "project" || this.image.type === "user" || this.image.file_type === "projectfile") {
          if (this.imageIsConverted) {
            this.getProjectFileImagePreview(data).then((res) => {
              this.imageUrl = res;
            });
          } else {
            this.imageUrl = "";
          }
        } else if (this.image.type === "template" || this.image.file_type === "templatefile") {
          if (this.imageIsConverted) {
            this.getTemplateFilePreview(data).then((res) => {
              this.imageUrl = res;
            });
          } else {
            this.imageUrl = "";
          }
        } else if (this.image.type === "library" || this.image.file_type === "libraryfile") {
          if (this.imageIsConverted) {
            this.getLibraryImagePreview(data).then((res) => {
              this.imageUrl = res;
            });
          } else {
            this.imageUrl = "";
          }
        }
      }
    },
    untilReadyImage() {
      const data = {
        file: this.image.uid,
        folder: this.image.folder,
        project: this.currentProject.uid,
        customLoading: true,
      };
      if (!this.imageIsReady) {
        const vm = this;
        vm.imageTimer = setTimeout(function () {
          if (vm.image.type === "library") {
            vm.getLibraryFile(data)
              .then((response) => {
                vm.image = response;
                vm.imageAmountTry = vm.imageAmountTry - 1;
                if (vm.imageAmountTry <= 0) {
                  vm.imageAmountTry = 10;
                  vm.imageTimeWaitStart = vm.imageTimeWaitStart + 60000;
                }
                vm.untilReadyImage();
              })
              .catch();
          } else {
            vm.getProjectFile(data)
              .then((response) => {
                vm.image = response;
                vm.imageAmountTry = vm.imageAmountTry - 1;
                if (vm.imageAmountTry <= 0) {
                  vm.imageAmountTry = 10;
                  vm.imageTimeWaitStart = vm.imageTimeWaitStart + 60000;
                }
                vm.untilReadyImage();
              })
              .catch();
          }
        }, vm.imageTimeWaitStart);
      } else {
        this.getImagePreview();
      }
    },
    getVideoPreview() {
      this.videoUrl = "";
      const data = {
        team: this.$route.params.team,
        project: this.currentProject.uid,
        template: this.currentProject.template.uid,
        file: this.video.uid,
        customLoading: true,
        folder: this.selectedFileFolder || this.video.folder,
        params: {
          width: Math.round(290 / this.video.ratio),
          height: "290",
        },
      };
      if (this.video) {
        if (this.video.type === "project" || this.video.type === "user" || this.video.file_type === "projectfile") {
          if (this.videoIsConverted) {
            this.getProjectFilePreview(data).then((res) => {
              this.videoUrl = res;
            });
          } else {
            this.videoUrl = "";
          }
        } else if (this.video.type === "template" || this.video.file_type === "templatefile") {
          if (this.videoIsConverted) {
            this.getTemplateFilePreview(data).then((res) => {
              this.videoUrl = res;
            });
          } else {
            this.videoUrl = "";
          }
        } else if (this.video.type === "library" || this.video.file_type === "libraryfile") {
          if (this.videoIsConverted) {
            this.getLibraryFilePreview(data)
              .then((res) => {
                this.videoUrl = res;
              })
              .catch((err) => {
                console.log("err", err);
              });
          } else {
            this.videoUrl = "";
          }
        }
      }
    },
    untilReadyVideo() {
      const data = {
        file: this.video.uid,
        folder: this.video.folder ?? null,
        project: this.currentProject.uid,
        customLoading: true,
      };
      if (!this.videoIsReady) {
        const vm = this;
        vm.videoTimer = setTimeout(function () {
          if (vm.video.type === "library") {
            vm.getLibraryFile(data)
              .then((response) => {
                vm.video = response;
                vm.videoAamountTry = vm.videoAamountTry - 1;
                if (vm.videoAamountTry <= 0) {
                  vm.videoAamountTry = 10;
                  vm.videoTimeWaitStart = vm.videoTimeWaitStart + 60000;
                }
                vm.untilReadyVideo();
              })
              .catch();
          } else {
            vm.getProjectFile(data)
              .then((response) => {
                vm.video = response;
                vm.videoAamountTry = vm.videoAamountTry - 1;
                if (vm.videoAamountTry <= 0) {
                  vm.videoAamountTry = 10;
                  vm.videoTimeWaitStart = vm.videoTimeWaitStart + 60000;
                }
                vm.untilReadyVideo();
              })
              .catch();
          }
        }, vm.videoTimeWaitStart);
      } else {
        this.getVideoPreview();
      }
    },
    isConvertedCalculate(item) {
      return this.statiBits ? this.$h.globalIsBitSet(item.status, this.statiBits.CONVERTED.bit) : false;
    },
    isReadyCalculate(item) {
      if (item) {
        if (this.statiBits && item.status) {
          return (
            this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "VIRUS_SCANNING" &&
            this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "CONVERTING"
          );
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    adjustAfterResize() {
      this.imageMaxWidth = this.globalCalculateImageSize(this.image);
      this.videoMaxWidth = this.globalCalculateImageSize(this.video);
    },
    globalCalculateImageSize(item) {
      return item ? 300 / (item.ratio ? item.ratio : 1) : 0;
    },
    loadProjectContact(d) {
      this.setChangedComp();
      const vm = this;
      const data = {
        project: vm.currentProject.uid,
        contact: d.uid,
      };
      vm.getProjectContact(data)
        .then((r) => {
          this.componentContact = r.data.data;
          this.contactHasChanged = true;
          this.imageHasChanged = true;
          this.videoHasChanged = true;
          const res = r.data.data;
          vm.image = res.image_override;
          if (vm.image) {
            vm.untilReadyImage();
            vm.addImage = true;
          } else {
            vm.addImage = false;
          }
          vm.video = res.video_override;
          if (vm.video) {
            vm.untilReadyVideo();
            vm.addVideo = true;
          } else {
            vm.addVideo = false;
          }
        })
        .catch();
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      currentProject: "projects_get_current_project",
      statiBits: "global_get_fileStatiBits",
    }),
    imageIsConverted() {
      return this.isConvertedCalculate(this.image);
    },
    imageIsReady() {
      return this.isReadyCalculate(this.image);
    },
    videoIsConverted() {
      return this.isConvertedCalculate(this.video);
    },
    videoIsReady() {
      return this.isReadyCalculate(this.video) && this.video.type !== null;
    },
  },
  watch: {
    videoUrl: function () {
      if (this.videoUrl !== "") {
        this.videoIsLoaded = true;
        this.setPlayerOptions();
        if (this.playerOptions.sources) {
          this.playerOptions.sources[0].src = this.videoUrl;
        }
        this.videoOptionsSet = true;
        this.$nextTick(() => {
          if (this.videoIsReady && this.$refs.videoPlayer) {
            this.$refs.videoPlayer.player.src(this.videoUrl);
          }
        });
        this.adjustAfterResize();
      }
    },
  },
};
</script>
<style lang="scss">
.video-player.video-player-box {
  @apply h-full relative;
  opacity: 0;
  transition: opacity 1s;
  .vjs-big-play-button {
    top: calc(50% - 22.5px);
    left: calc(50% - 45px);
  }
  .video-js.vjs-fluid {
    @apply h-full;
  }
}
.video-player.video-player-box.video-loaded {
  opacity: 1;
}
</style>
